import React from 'react'
import { motion } from 'framer-motion'
import Navigation from './Navigation'
import Footer from './Footer'
import { cn } from '../utils'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 transition-colors duration-300">
      {/* Skip to content link for accessibility */}
      <a
        href="#main-content"
        className={cn(
          'sr-only focus:not-sr-only',
          'fixed top-4 left-4 z-[60]',
          'bg-primary-500 text-white px-4 py-2 rounded-lg',
          'font-medium text-sm',
          'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2',
          'transition-transform duration-200'
        )}
      >
        Skip to main content
      </a>

      <Navigation />

      <motion.main
        id="main-content"
        className="flex-1 relative z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.main>

      <Footer />
    </div>
  )
}

export default Layout
